import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@shared/ui/Skeleton';
import { IconArrowRight } from '@shared/ui/icons';
import {
  Tile,
  TileArrow,
  TileHeader,
  TileHeaderContent,
  TileIcon,
  TileNote,
  TileSkeletonMetrics,
  TileTitle,
} from './styles';
import type { TileShellProps } from './types';

export function TileShell({
  to,
  delay,
  icon: Icon,
  title,
  note,
  disabled,
  accent,
  children,
}: TileShellProps) {
  const navigate = useNavigate();
  return (
    <Tile
      $delay={delay}
      $disabled={disabled}
      $accent={accent}
      onClick={() => {
        if (!disabled) navigate(to);
      }}
    >
      <TileHeader>
        <TileIcon>
          <Icon size={20} />
        </TileIcon>
        <TileHeaderContent>
          <TileTitle>{title}</TileTitle>
          {note && <TileNote>{note}</TileNote>}
        </TileHeaderContent>
      </TileHeader>
      {children}
      <TileArrow>
        <IconArrowRight size={18} />
      </TileArrow>
    </Tile>
  );
}

// Малозаметный плейсхолдер тайла, пока грузятся цифры из API.
// Размеры соответствуют BigNumber + 2 строкам Metrics, чтобы тайл не
// «прыгал» после первого fetch.
export function TileSkeleton() {
  return (
    <>
      <Skeleton $width={72} $height={32} />
      <TileSkeletonMetrics>
        <Skeleton $width={80} $height={12} />
        <Skeleton $width={80} $height={12} />
      </TileSkeletonMetrics>
    </>
  );
}
